const backgroundColors = {
  colors: {
    default: 'u-bgColorLightGrey',
    white: 'u-bgColorWhite',
    lightGrey: 'u-bgColorLightGrey',
    brandMedium: 'u-bgColorBrandMedium',
    brandDark: 'u-bgColorBrandDark',
    transparentWhite: 'u-bgColorTransparent',
  },
  get: function (bgColor) {
    return this.colors[bgColor] || this.colors.default
  },
}

const verticalAlignments = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
}
// TODO: use this to replace the "cardAlignment" option
const columns = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
}

const textAlignments = {
  left: '',
  center: 'u-textCenter',
  right: 'u-textRight',
}

const headingColors = {
  brandDark: 'u-textColorBrandDark',
  brandMedium: 'u-textColorBrandMedium',
  teal: 'u-textColorBrandTeal',
  raspberry: 'u-textColorBrandRaspberry',
  yellow: 'u-textColorBrandYellow',
  aqua: 'u-textColorBrandAqua',
  white: 'u-textColorWhite',
}
const textColors = {
  default: '',
  white: 'u-textColorWhite',
}

const images = {
  Image1: '/cti-site/webfiles/latest/assets/cti/Statistics/images/bg-example-1.jpg',
  Image2: '/cti-site/webfiles/latest/assets/cti/Statistics/images/bg-example-2.jpg',
  Image3: '/cti-site/webfiles/latest/assets/cti/Statistics/images/bg-example-3.jpg',
}

export {
  backgroundColors,
  columns,
  textAlignments,
  headingColors,
  textColors,
  images,
  verticalAlignments,
}
